import { render } from "./AHJTablePagination.vue?vue&type=template&id=8ce85fd0&scoped=true"
import script from "./AHJTablePagination.vue?vue&type=script&lang=js"
export * from "./AHJTablePagination.vue?vue&type=script&lang=js"

import "./AHJTablePagination.vue?vue&type=style&index=0&id=8ce85fd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ce85fd0"]])

export default __exports__